// Демо-форма подсказок по произвольным справочникам.

import createComponent from "../vue";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

function loadType(defaultType) {
    const type = localStorage.getItem("outward_type");
    return type || defaultType;
}

function saveType(type) {
    localStorage.setItem("outward_type", type);
}

const STATE = {
    data: null,
    type: loadType("fms_unit"),
    value: "",
};

const methods = {
    initSuggestions(serviceUrl, token) {
        const el = $(this.$refs.input);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        el.suggestions(params);
    },

    onSelect(suggestion) {
        this.value = suggestion.value;
        this.data = suggestion.data;
        Analytics.reachGoal("SUG_DEMO_FORM_OTHERS");
    },

    onSelectNothing(query) {
        this.value = query;
        this.data = null;
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
        },
        watch: {
            type(val) {
                saveType(val);
                this.value = "";
                this.data = null;
                this.initSuggestions(serviceUrl, token);
            },
        },
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const outwardConfig = buildConfig(serviceUrl, token);

    createComponent(outwardConfig, "#outward-vue-app");
}
